import { LogoMark } from "./Logo";
import { scrollToId } from "../../lib/scroll";
import { useLang } from "../../lib/i18n";

export const Footer = () => {
  const { t } = useLang();
  return (
  <footer data-testid="site-footer" className="overflow-hidden border-t border-[#E6D9BC]/10 bg-[#162026]">
    <div className="mx-auto max-w-[1440px] px-5 pt-20 md:px-10">
      <div className="flex flex-col justify-between gap-8 md:flex-row md:items-center">
        <LogoMark className="h-12 w-auto text-[#E6D9BC]" />
        <div className="flex flex-wrap gap-8 font-mono text-xs uppercase tracking-[0.2em] text-[#BAC6CE]">
          {["home", "order-pack", "installation", "contact-us"].map((id, i) => (
            <button key={id} data-testid={`footer-link-${id}`} onClick={() => scrollToId(id)} className="sw-link hover:text-[#F4EFE6]">{t.nav[i]}</button>
          ))}
        </div>
      </div>
      <p className="mt-16 select-none whitespace-nowrap font-sans text-[19vw] font-light leading-[0.8] tracking-[-0.05em] text-[#E6D9BC]/90">Space Wise</p>
      <div className="flex flex-col justify-between gap-2 border-t border-[#E6D9BC]/10 py-6 text-xs text-[#A3B2BC] sm:flex-row">
        <span>{t.rights}</span>
        <span>{t.tagline}</span>
      </div>
    </div>
  </footer>
  );
};
